import api from '.';

import { buildQueryWithParams } from '../../Utils/api';


const statusNotifications = api.injectEndpoints({
    endpoints: (builder) => ({
        requestStatusNotifications: builder.query({
            query: ({filter,id}) => ({
                url: buildQueryWithParams(`/charge-points/${id}/charge-point-status-notifications`, {filter}),
            }),
            transformResponse: (res) => ({
                list: res
            }),

        })
    })
});
export const {
    useRequestStatusNotificationsQuery,
} = statusNotifications;
